function makeBackMoveTask(task: MoveTask): MoveTask {
    let result: MoveTask = {
        logic: [],
        physics: []
    };

    getLogicTask(result.logic, task.logic);
    getPhysicsTask(result.physics, task.physics);

    return result;
}

function getLogicTask(result: LogicMoveTask[], srcTask: LogicMoveTask[]): void {
    srcTask.forEach((logicTask: LogicMoveTask): void => {
        result.push({
            from: {
                parent: logicTask.to.parent,
                moveTarget: logicTask.to.moveTarget,
                before: logicTask.to.insertBefore,
            },
            to: {
                parent: logicTask.from.parent,
                moveTarget: logicTask.from.moveTarget,
                insertBefore: logicTask.from.before
            }
        });
    });
}

function getPhysicsTask(result: PhysicsMoveTask[], srcTask: PhysicsMoveTask[]): void {
    srcTask.forEach((physicsTask: PhysicsMoveTask): void => {
        result.push({
            from: {
                moveTarget: physicsTask.to.moveTarget,
                position: {
                    left: physicsTask.to.position.left,
                    bottom: physicsTask.to.position.bottom
                }
            },
            to: {
                moveTarget: physicsTask.from.moveTarget,
                position: {
                    left: physicsTask.from.position.left,
                    bottom: physicsTask.from.position.bottom
                }
            }
        });
    });
}

function makeAddSubBackMoveTask(task: MoveTask): MoveTask {
    let result: MoveTask = {
        logic: [],
        physics: []
    };

    getLogicTask(result.logic, task.logic);
    getPhysicsTask(result.physics, task.physics);

    return result;
}

export {
    makeBackMoveTask,
    makeAddSubBackMoveTask
};
